export const LOGIN="LOGIN";
export const REGISTER="REGISTER";
export const OTP = "OTP";
export const FORGOTPASSWORD = "FORGOTPASSWORD";
export const LOGOUT = "LOGOUT";